var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66346 20.6315C2.51734 19.5245 1.60315 18.2004 0.974242 16.7363C0.345334 15.2723 0.0142989 13.6976 0.000453081 12.1043C-0.0133927 10.5109 0.290228 8.93077 0.893598 7.45601C1.49697 5.98125 2.38801 4.64143 3.51472 3.51472C4.64143 2.38801 5.98125 1.49697 7.45601 0.893598C8.93077 0.290228 10.5109 -0.0133927 12.1043 0.000453081C13.6976 0.0142989 15.2723 0.345334 16.7363 0.974242C18.2004 1.60315 19.5245 2.51734 20.6315 3.66346C22.8174 5.92668 24.0269 8.95791 23.9995 12.1043C23.9722 15.2506 22.7102 18.2604 20.4853 20.4853C18.2604 22.7102 15.2506 23.9722 12.1043 23.9995C8.95791 24.0269 5.92668 22.8174 3.66346 20.6315ZM5.35546 18.9395C7.15681 20.7408 9.59996 21.7528 12.1475 21.7528C14.695 21.7528 17.1381 20.7408 18.9395 18.9395C20.7408 17.1381 21.7528 14.695 21.7528 12.1475C21.7528 9.59996 20.7408 7.15681 18.9395 5.35546C17.1381 3.55411 14.695 2.54212 12.1475 2.54212C9.59996 2.54212 7.15681 3.55411 5.35546 5.35546C3.55411 7.15681 2.54212 9.59996 2.54212 12.1475C2.54212 14.695 3.55411 17.1381 5.35546 18.9395ZM17.2355 8.75146L13.8395 12.1475L17.2355 15.5435L15.5435 17.2355L12.1475 13.8395L8.75146 17.2355L7.05946 15.5435L10.4555 12.1475L7.05946 8.75146L8.75146 7.05946L12.1475 10.4555L15.5435 7.05946L17.2355 8.75146Z",
    fill: "#730E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/closeModalIcon.a839b35af59ef020b23fe3e565a0eaa3.svg";
export { ForwardRef as ReactComponent };